import { webAudioContext } from "./webaudio_context";
import { webAudioUtils } from "./webaudio_utils";
import { NodeHtml } from "./node_html";

class MediaSourceHtml extends NodeHtml {
  handlers = this.extendParentHandlers({
    volume: { handler: this.setVolume, type: "float", default: 0, min: -80, max: 12 },
  });
  setProps(dnode) {
    dnode.output = webAudioContext.context.createGain();
    dnode.output.gain.value = webAudioUtils.dbToJs(dnode.props.volume);

    const container = document.querySelector('[data-uid="' + dnode.props.mediaSourceUid + '_node"]');
    if (!container) {
      console.warn("MediaSource container not found for uid:", dnode.props.mediaSourceUid);
      super.setProps(dnode);
      return;
    }
    const element = container.querySelector("audio") || container.querySelector("video");
    if (!element) {
      console.warn("MediaSource audio/video element not found in container:", dnode.props.mediaSourceUid);
      super.setProps(dnode);
      return;
    }
    const source = webAudioContext.context.createMediaElementSource(element);

    source.connect(dnode.output);
    super.setProps(dnode);
  }

  setVolume(dnode) {
    dnode.output.gain.value = webAudioUtils.dbToJs(dnode.props.volume);
  }
}

const mediaSourceHtml = new MediaSourceHtml("webaudio:mediaSourceNode");
export { mediaSourceHtml, MediaSourceHtml };
